var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircelFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 590,
    height: 596,
    viewBox: "0 0 590 596",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M308.894 0H280.398V595.924H308.894V0Z",
    fill: "#00AFE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M589.296 283.552H0V312.368H589.296V283.552Z",
    fill: "#00AFE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3213 77.0597L76.1719 97.4358L492.863 518.814L513.012 498.438L96.3213 77.0597Z",
    fill: "#00AFE1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M492.867 77.0605L76.1758 498.439L96.3253 518.815L513.016 97.4367L492.867 77.0605Z",
    fill: "#00AFE1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.232 172.294L16.4805 198.98L562.227 423.823L572.979 397.136L27.232 172.294Z",
    fill: "#00AFE1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M392.716 16.7129L170.375 568.599L196.765 579.471L419.106 27.5853L392.716 16.7129Z",
    fill: "#00AFE1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M562.877 173.293L16.1875 395.811L26.8279 422.544L573.518 200.026L562.877 173.293Z",
    fill: "#00AFE1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M197.686 16.3783L171.25 27.1355L391.234 579.974L417.67 569.217L197.686 16.3783Z",
    fill: "#00AFE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircelFlag);
export default __webpack_public_path__ + "static/media/circel-flag.869a8f5352c36662045625618cb07279.svg";
export { ForwardRef as ReactComponent };